// Port of ecommerce/lib.coffee formatWeeks. Subscription intervals are stored in weeks;
// anything from two months up that divides evenly reads better as months.
import { pluralize } from '@aytm/app/stats/lib/util/helpers'

export const formatWeeks = (w, full = false) => {
  if (w >= 8 && w % 4 === 0) {
    return full ? `${w / 4} months` : `${w / 4}m`
  }
  return full ? `${w} ${pluralize(w, 'week', 'weeks')}` : `${w}w`
}
